
import { defineComponent, ref, onUnmounted, computed, PropType, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import AppDropdown from '@/components/atoms/AppDropdown.vue'
import FlexibleContent from '@/components/layout/FlexibleContent.vue'

import RoutePlaces from '@/components/route/RoutePlaces.vue'
import LiveSummary from '@/components/live/LiveSummary.vue'


import { store } from '@/store'
import { prevPlace, validateDriverSecret } from '@/api/tripply/live'
import { Route, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'Route',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    }
  },
  components: { AppDropdown, FlexibleContent, RoutePlaces, LiveSummary },
  setup(props) {
    const router = useRouter()
    const routeId = router.currentRoute.value.params.id as string
    const driverSecret = router.currentRoute.value.query.d    

    onMounted(() => {
      store.live.initialize(routeId)      
    })

    const minimizePlaces = ref(false)

    const user = store.user.get(state => state.user)
    const isOwner = computed(() => store.user.isOwner(routeId))    
    const isDriver = computed(() => driverSecret && validateDriverSecret(routeId, driverSecret as string))

    function endLive() {
      store.route.endLive(routeId)
    }

    function resetLive() {
      store.live.resetLive(routeId)
    }

    function assignDriver() {
      store.modal.showModal('AssignDriver', {route: props.route})
    }

    function prev() {
      prevPlace(routeId)
    }
    function shareRoute() {
      store.route.share(props.route.id)
    }

    onUnmounted(() => {
      store.live.terminate(routeId)
    })

    return { store, user, isOwner, isDriver, prev, routeId, assignDriver, endLive, resetLive, shareRoute, minimizePlaces }
  },
})
